import { AppBar, Box, Container, Toolbar } from '@mui/material';

const Header = () => (
  <AppBar position="static" elevation={0} color="default" sx={{ bgcolor: '#ffffff', borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
    <Container maxWidth={false} disableGutters>
      <Toolbar sx={{ justifyContent: 'center', alignItems: 'center', minHeight: { xs: 85, md: 120 }, px: { xs: 1.5, sm: 2 }, py: { xs: 0.5, md: 1 } }}>
        <Box component="img" src="/Smartly-rich-logo.png" alt="Cashout Equity" sx={{ height: { xs: 72, md: 110 }, maxHeight: '80vh' }} />
      </Toolbar>
    </Container>
  </AppBar>
);

export default Header;
